import angular from 'angular'

import template from '../../../templates/customer/wr-customer-balances.html'

/**
 * Directive to display the available balances for a given customer.
 *
 * @module webregister.directives.wrCustomerBalances
 */
angular
  .module('webregister.directives')
  .directive('wrCustomerBalances', function (vdFeatureManager) {
    return {
      scope: {
        customer: '=',
        customerBalances: '=',
      },
      restrict: 'E',
      template,
      bindToController: true,
      controllerAs: 'customerBalancesCtrl',
      /**
       * =======================================
       * CUSTOMER BALANCES CONTROLLER
       * =======================================
       */
      controller(this: $TSFixMe, retailerSettingsManager) {
        this.loyaltyEnabled = retailerSettingsManager.isLoyaltyEnabled()
        this.isStoreCreditEnabled = retailerSettingsManager.isStoreCreditEnabled()
      },
    }
  })
